<script>
import { FormMixin } from '@artup/client'
import ViewMixin from './view'

export default {
  mixins: [
    FormMixin,
    ViewMixin
  ],
}

</script>

<template>
  <main class="artup-account-view welcome">
    <div class="text-h5 q-mb-md">
      Welcome, {{ account.fullName }}
    </div>
    <div v-if="account.lastLogin">
      Your last login was on {{ datetime(account.lastLogin) }}
    </div>
  </main>
</template>

<style scoped lang="scss">
@import "./view.scss";
</style>
